var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished-button-container"},[_c('button',{staticClass:"finished-complete-button",on:{"click":function($event){return _vm.$emit('finished')}}},[_vm._v("I'm finished with Step "+_vm._s(_vm.step))])])}
var staticRenderFns = []

export { render, staticRenderFns }